<script lang="ts">
	import { SvgWrapper } from '../../../storybook-util/icons/components/SvgWrapper';
	import { getTailwindColor } from '../../../storybook-util/icons/utils/getTailwindColor/getTailwindColor';
	interface Props {
		color?: string | undefined;
		title?: string | undefined;
		class?: string;
	}

	let { color = 'gray-900', title = undefined, ...rest }: Props = $props();
</script>

<SvgWrapper {title} {...rest}>
	<path
		d="M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H11.025C11.4392 3 11.775 3.33579 11.775 3.75C11.775 4.16421 11.4392 4.5 11.025 4.5H5.5C4.94772 4.5 4.5 4.94772 4.5 5.5V18.5C4.5 19.0523 4.94772 19.5 5.5 19.5H11.025C11.4392 19.5 11.775 19.8358 11.775 20.25C11.775 20.6642 11.4392 21 11.025 21H4.5ZM16.65 16.375L15.575 15.3L18.125 12.75H9.375V11.25H18.075L15.525 8.7L16.6 7.625L21 12.025L16.65 16.375Z"
		fill={getTailwindColor(color)}
	/>
</SvgWrapper>
